/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var CollectionFlowStatusesEnum = {
  // Collection Flow created but never touched by end user
  pending: 'pending',
  // Collection Flow is in progress
  inprogress: 'inprogress',
  // Collection Flow is approved
  approved: 'approved',
  // Collection Flow is rejected
  rejected: 'rejected',
  // Collection Flow is in revision
  revision: 'revision',
  // Collection Flow failed (by plugins)
  failed: 'failed',
  // Collection Flow is completed (by end user)
  completed: 'completed',
  // Collection Flow is being edited by Agent
  edit: 'edit'
};

export { CollectionFlowStatusesEnum };
//# sourceMappingURL=collection-flow-status-enum.js.map
